import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface Provincia {
    id: number;
    nombre: string;
}

export interface Provincias {
    provincias: Provincia[];
}

export interface ObtenerListadoProvinciaPorPaisRequest{
  pais: {
    id: number
  }
}

export interface ObtenerListadoProvinciaPorPaisResponse extends ResponseMessageWithInternalStatus{
  provincias: 
    {
      id: number,
      nombre: string
    }[]
}

export interface ProvinciasState {
  provincias: Provincia[];
  error: boolean;
  debugMessage?: any;
} 

export const initialProvinciasState: ProvinciasState = {
  provincias: [],
  error: false,
  debugMessage: null
};
